import { createContext, useContext } from 'react';

import type { DrillRef } from '@/data-sources/contract/conversations';

export type DrillHandler = (ref: DrillRef) => void;

/** Provided by the conversations feature; absent → chart points are not clickable. */
export const DrillContext = createContext<DrillHandler | undefined>(undefined);

export const useDrill = () => useContext(DrillContext);
